import { publicContentApiClient } from '../api-fetcher/api-client';

export interface IPresenterLoginRequest{
    presenterLink: string;
    accessCode: string;
}

export interface IPresenterLoginResponse extends IPresenterLoginRequest {
    id: number;
    presentationId: number;
    token: string;
}

export const loginApi = async (body: IPresenterLoginRequest): Promise<IPresenterLoginResponse> => {
  return publicContentApiClient.post<IPresenterLoginResponse, IPresenterLoginRequest>('presenter/login', { ...body });
};
